import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { formatDate, formatCurrency } from '../utils/formatters';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function EmployeeProfile({ user, onLogout }) {
  const { id } = useParams();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEmployee();
  }, [id]);

  const fetchEmployee = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/employees/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEmployee(response.data);
    } catch (error) {
      console.error('Failed to fetch employee:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Layout user={user} onLogout={onLogout}><div className="p-6">Loading...</div></Layout>;
  if (!employee) return <Layout user={user} onLogout={onLogout}><div className="p-6">Employee not found</div></Layout>;

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold" style={{color: '#2b3380'}}>Employee Profile</h1>
          <div className="space-x-4">
            <Link to={`/employees/${id}/edit`} className="px-6 py-3 rounded-lg text-white font-medium" style={{backgroundColor: '#2b3380'}}>Edit</Link>
            <Link to="/employees" className="px-6 py-3 rounded-lg font-medium border">Back to List</Link>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full flex items-center justify-center text-4xl font-bold text-white" style={{backgroundColor: '#2b3380'}}>
                {employee.first_name[0]}{employee.last_name[0]}
              </div>
              <h2 className="text-2xl font-bold mb-2">{employee.first_name} {employee.last_name}</h2>
              <p className="text-gray-600 mb-2">{employee.designation}</p>
              <span className="px-3 py-1 rounded-full text-sm font-semibold text-white" style={{backgroundColor: employee.employee_status === 'Active' ? '#4caf50' : '#ff9800'}}>{employee.employee_status}</span>
              <div className="mt-4 pt-4 border-t text-left space-y-2">
                <p className="text-sm"><strong>Employee ID:</strong> {employee.employee_id}</p>
                <p className="text-sm"><strong>Email:</strong> {employee.official_email}</p>
                <p className="text-sm"><strong>Mobile:</strong> {employee.mobile_number}</p>
                <p className="text-sm"><strong>Department:</strong> {employee.departments?.join(', ')}</p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-xl font-bold mb-4" style={{color: '#2b3380'}}>Employment Details</h3>
              <div className="grid grid-cols-2 gap-4">
                <div><p className="text-sm text-gray-600">Date of Joining</p><p className="font-medium">{formatDate(employee.date_of_joining)}</p></div>
                <div><p className="text-sm text-gray-600">Employment Type</p><p className="font-medium">{employee.employment_type}</p></div>
                <div><p className="text-sm text-gray-600">Work Location</p><p className="font-medium">{employee.work_location || 'N/A'}</p></div>
                <div><p className="text-sm text-gray-600">Work Mode</p><p className="font-medium">{employee.work_mode}</p></div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-xl font-bold mb-4" style={{color: '#2b3380'}}>Compensation</h3>
              <div className="grid grid-cols-2 gap-4">
                <div><p className="text-sm text-gray-600">Basic Salary</p><p className="font-medium">{formatCurrency(employee.basic_salary)}</p></div>
                <div><p className="text-sm text-gray-600">Bank Name</p><p className="font-medium">{employee.bank_name || 'N/A'}</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
export default EmployeeProfile;
